var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.406 20a.593.593 0 0 1-.52-.313l-.017-.03c-1.776-3.241-5.16-5.257-8.83-5.257H9.917v3.4c0 .24-.144.458-.363.553a.59.59 0 0 1-.644-.123l-6.73-6.6a.6.6 0 0 1 0-.86l6.73-6.6a.59.59 0 0 1 .644-.123c.22.095.363.312.363.553v3.402C16.047 8.109 21 13.18 21 19.4a.599.599 0 0 1-.594.6zM9.323 13.2h1.716c3.306 0 6.404 1.463 8.522 3.929C18.536 12.594 14.512 9.2 9.719 9.2h-.396a.597.597 0 0 1-.594-.6V6.018L3.446 11.2l5.283 5.182V13.8c0-.331.266-.6.594-.6z",
    fill: "#979BA1",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReply);
export default __webpack_public_path__ + "static/media/iconReply.ecd60e23.svg";
export { ForwardRef as ReactComponent };